module.exports = __webpack_public_path__ + "img/874-b0c402.png";